import { createFileRoute } from "@tanstack/react-router";
import TmsForDepressionAfterMedicationFailure from "@/pages/TmsForDepressionAfterMedicationFailure";
export const Route = createFileRoute(
  "/tms-for-depression-after-medication-failure",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "TMS For Depression After Medication Failure | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS for depression after medication hasn’t worked. Learn about SAINT TMS and standard TMS options in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content:
            "TMS For Depression After Medication Failure | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS for depression after medication hasn’t worked. Learn about SAINT TMS and standard TMS options in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/tms-for-depression-after-medication-failure",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-for-depression-after-medication-failure",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsForDepressionAfterMedicationFailure />;
}
